import { styled, TableCell, TableRow, TextField } from '@mui/material';

export const InformationH2 = styled('h2')({
  fontSize: '14px',
  color: '#000000',
  opacity: '60%',
  fontWeight: '400',
});

export const InformationP = styled('p')({
  color: 'rgba(0, 0, 0, 0.87)',
  fontSize: '16px;',
  margin: 0,
});

export const InformationLocationH2 = styled('h2')({
  fontSize: '12px',
  color: '#000000',
  opacity: '38%',
  fontWeight: '400',
});

export const InformationChipStyle = {
  fontSize: '0.8125rem',
  color: '#000000',
  opacity: '87%',
  backgroundColor: '#E0E0E0',
  borderRadius: '16px',
};

export const LocationList = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
});

export const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    opacity: '87%',
    backgroundColor: '#FAFAFA',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const StyledTableCell = styled(TableCell)(() => ({
  fontWeight: '600',
}));

export const StyledFieldSet = styled('fieldset')(() => ({
  border: 0,
  padding: 0,
}));

export const StyledTextField = styled(TextField)(() => ({
  width: '100%',
}));
